/*
 * Kinsora checkout P0 fixes (Clarity review 2026-10-30, KIN-003).
 * 1. Sign-in return: Shopify sends shoppers who sign in (Shop / customer
 *    accounts) from checkout back to /cart?logged_in=true. Forward them to
 *    /checkout once, as soon as the cart's own Checkout link is ready.
 * 2. Mobile cart drawer: keep the Checkout footer visible while a gift
 *    picker sheet is open by publishing the footer height as a CSS variable.
 * 3. QA traffic: utm_source=qa marks the session (cookie ks_qa=1, Clarity
 *    custom tag traffic_type=qa) so reporting and the checkout pixel can
 *    exclude it.
 */
(function () {
  'use strict';
  if (window.KinsoraCheckoutP0) return;
  window.KinsoraCheckoutP0 = true;

  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }

  /* ---- 3. QA traffic marker ---- */
  function isQa() {
    if (params && String(params.get('utm_source') || '').toLowerCase() === 'qa') return true;
    return /(?:^|;\s*)ks_qa=1(?:;|$)/.test(document.cookie);
  }
  if (isQa()) {
    try { document.cookie = 'ks_qa=1; path=/; max-age=86400; SameSite=Lax'; } catch (e) {}
    var tagTries = 0;
    (function tagClarity() {
      if (typeof window.clarity === 'function') {
        try { window.clarity('set', 'traffic_type', 'qa'); } catch (e) {}
        return;
      }
      if (++tagTries < 20) setTimeout(tagClarity, 500);
    })();
  }

  /* ---- 1. Sign-in return to checkout ---- */
  var GUARD_KEY = 'ks.signinCheckoutReturn';
  var GUARD_MS = 2 * 60 * 1000;
  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }
  function cameFromSignIn() {
    if (!params) return false;
    return params.get('logged_in') === 'true' || params.get('shop_sign_in') === 'true';
  }
  function recentlyForwarded() {
    try {
      var at = Number(window.sessionStorage.getItem(GUARD_KEY) || 0);
      return at > 0 && Date.now() - at < GUARD_MS;
    } catch (e) { return true; }
  }
  function readyCheckoutLink() {
    var links = document.querySelectorAll('.cart-page-checkout-btn, .cart-page-mobile-checkout, #cartDrawer .ks-cart-footer__checkout');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var href = link.getAttribute('href');
      if (href && link.getAttribute('aria-disabled') !== 'true' && link.dataset.kinsoraPromotionBlocked !== 'true') return href;
    }
    return '';
  }
  function forwardToCheckout() {
    if (!onCartPage() || !cameFromSignIn() || recentlyForwarded()) return;
    var started = Date.now();
    (function attempt() {
      var href = readyCheckoutLink();
      if (href) {
        try { window.sessionStorage.setItem(GUARD_KEY, String(Date.now())); } catch (e) {}
        window.location.replace(href);
        return;
      }
      // The cart page enables its Checkout link only after its cart checks
      // finish. If it never becomes ready (empty cart, blocked promo), stay.
      if (Date.now() - started < 6000) setTimeout(attempt, 250);
    })();
  }

  /* ---- 2. Keep the drawer Checkout visible over gift sheets ---- */
  var observed = new WeakSet();
  function syncFooterHeight(drawer) {
    var footer = drawer.querySelector('.ks-cart-footer');
    var height = footer && !footer.hidden ? footer.getBoundingClientRect().height : 0;
    drawer.style.setProperty('--ks-cart-footer-h', Math.round(height) + 'px');
  }
  function watchDrawer() {
    document.querySelectorAll('.ks-cart-section .ks-cart').forEach(function (drawer) {
      syncFooterHeight(drawer);
      var footer = drawer.querySelector('.ks-cart-footer');
      if (footer && window.ResizeObserver && !observed.has(footer)) {
        observed.add(footer);
        new ResizeObserver(function () { syncFooterHeight(drawer); }).observe(footer);
      }
    });
  }

  function init() { watchDrawer(); forwardToCheckout(); }
  document.addEventListener('kinsora:cart-drawer-updated', watchDrawer);
  document.addEventListener('shopify:section:load', watchDrawer);
  window.addEventListener('resize', watchDrawer);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
